/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryOut } from '../models/CountryOut';
import type { MasterCreate } from '../models/MasterCreate';
import type { MasterOut } from '../models/MasterOut';
import type { MasterTableValuesOut } from '../models/MasterTableValuesOut';
import type { MasterUpdate } from '../models/MasterUpdate';
import type { StateOut } from '../models/StateOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MastersService {
    /**
     * Get Master Model Names
     * Return the list of available master tables (keys from Masters dict).
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getMasterModelNamesMastersGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/masters/',
        });
    }
    /**
     * Create Master
     * @param modelName
     * @param requestBody
     * @returns MasterOut Successful Response
     * @throws ApiError
     */
    public static createMasterMastersModelNamePost(
        modelName: string,
        requestBody: MasterCreate,
    ): CancelablePromise<MasterOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/masters/{model_name}',
            path: {
                'model_name': modelName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fetch Master
     * @param modelName
     * @param skip
     * @param limit
     * @returns MasterTableValuesOut Successful Response
     * @throws ApiError
     */
    public static fetchMasterMastersModelNameGet(
        modelName: string,
        skip?: number,
        limit: number = 50,
    ): CancelablePromise<Array<MasterTableValuesOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/masters/{model_name}',
            path: {
                'model_name': modelName,
            },
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fetch Countries Endpoint
     * @returns CountryOut Successful Response
     * @throws ApiError
     */
    public static fetchCountriesEndpointMastersCountriesGet(): CancelablePromise<Array<CountryOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/masters/countries',
        });
    }
    /**
     * Fetch State Endpoint
     * @param countryId
     * @returns StateOut Successful Response
     * @throws ApiError
     */
    public static fetchStateEndpointMastersStatesCountryIdGet(
        countryId: number,
    ): CancelablePromise<Array<StateOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/masters/states/{country_id}',
            path: {
                'country_id': countryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fetch Master Raw
     * @param modelName
     * @param skip
     * @param limit
     * @returns any Successful Response
     * @throws ApiError
     */
    public static fetchMasterRawMastersRawModelNameGet(
        modelName: string,
        skip?: number,
        limit: number = 50,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/masters/raw/{model_name}',
            path: {
                'model_name': modelName,
            },
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Master
     * @param modelName
     * @param id
     * @returns MasterOut Successful Response
     * @throws ApiError
     */
    public static getMasterMastersModelNameIdGet(
        modelName: string,
        id: number,
    ): CancelablePromise<MasterOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/masters/{model_name}/{id}',
            path: {
                'model_name': modelName,
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Master
     * @param modelName
     * @param id
     * @param requestBody
     * @returns MasterOut Successful Response
     * @throws ApiError
     */
    public static updateMasterMastersModelNameIdPut(
        modelName: string,
        id: number,
        requestBody: MasterUpdate,
    ): CancelablePromise<MasterOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/masters/{model_name}/{id}',
            path: {
                'model_name': modelName,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Master
     * @param modelName
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteMasterMastersModelNameIdDelete(
        modelName: string,
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/masters/{model_name}/{id}',
            path: {
                'model_name': modelName,
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
